import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Ahorra {{percentageAmount}}% en artículos seleccionados',
    description:
      'Ahorra {{percentageAmount}}% en tu pedido al pedir artículos seleccionados. La oferta es válida{{fromTo}} hasta que se alcance el límite máximo de promociones, lo que ocurra primero. No acumulable con otras promociones.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% de descuento desde {{minSpendValue}}',
    description:
      'Ahorra {{percentageAmount}}% en tu pedido. La oferta es válida{{fromTo}} hasta que se alcance el límite máximo de promociones, lo que ocurra primero. No acumulable con otras promociones.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Ahorra {{amount}} en artículos seleccionados',
    description:
      'Ahorra {{amount}} al pedir artículos seleccionados. La oferta es válida{{fromTo}} hasta que se alcance el límite máximo de promociones, lo que ocurra primero. No acumulable con otras promociones.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Ahorra {{amount}} desde {{minSpendValue}}',
    description:
      'Ahorra {{amount}} con un valor de pedido. La oferta es válida{{fromTo}} hasta que se alcance el límite máximo de promociones, lo que ocurra primero. No acumulable con otras promociones.',
  },
  [OfferKindEnum.Bogo]: {
    title: '¡2 por el precio de 1!',
    description:
      'Compra un artículo y llévate el segundo gratis. La oferta es válida{{fromTo}} hasta que se alcance el límite promocional, lo que ocurra primero. No acumulable con otras promociones.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: '¡Llévate el segundo al 50%!',
    description:
      'Compra un artículo y llévate el segundo al 50%. La oferta es válida{{fromTo}} hasta que se alcance el límite promocional, lo que ocurra primero. No acumulable con otras promociones.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Artículo gratis con un importe de pedido',
    description:
      'Recibe un artículo gratis al cumplir las condiciones de la oferta. La oferta es válida{{fromTo}} hasta que se alcance el límite promocional, lo que ocurra primero. No acumulable con otras promociones.',
    reward_items_description: 'Elige tu artículo gratis.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Artículo gratis con tu pedido',
    description:
      'Recibe un artículo gratis al cumplir las condiciones de la oferta. La oferta es válida{{fromTo}} hasta que se alcance el límite promocional, lo que ocurra primero. No acumulable con otras promociones.',
    qualifying_items_description: 'Selecciona los artículos que el cliente debe pedir para obtener el artículo gratis.',
    reward_items_description: 'Elige tu artículo gratis.',
  },
};

export default {
  offers,
  from_to: ' desde {{startsAt}} hasta {{endsAt}} o',
  qualifying_items_title: 'Artículos elegibles',
  reward_items_title: 'Artículos gratis',
  buttons: {
    add: 'Añadir al carrito',
  },
};
